import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { useSelector } from 'react-redux';
import { fail_retrieve_sales_rep_tenant_order_list, loading_retrieve_sales_rep_tenant_order_list, reset_retrieve_sales_rep_tenant_order_list, success_retrieve_sales_rep_tenant_order_list } from '../../../reducers/auth_tenant/retrieve_sales_rep_tenant_order_list_Slice';
import * as app_consts from "../../../utils/app_consts";
import { RETRIEVE_TENANT_ORDERS_LIST_ERROR_MSG, RETRIEVE_TENANT_ORDERS_LIST_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { formatToSentenceCase, messageToast } from '../../../utils/Utils';
import { Link } from 'react-router-dom';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import { RETRIEVE_SALES_REP_TENANT_ORDERS_LIST_API, SALES_REP_APPROVER_RETRIEVE_ORDER_LIST_API } from '../../../api/api_data';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { Badge } from 'reactstrap';
import moment from 'moment';

const AllOrders = ({ tenant_info, user_info }) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sm, updateSm] = useState(false);
  const [itemPerPage] = useState(10);
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    retrieve_orders();
  }, []);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate the start and end index for the current page
  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;

  // UseEffect for Search 
  useEffect(() => {
    filtered_orders(searchTerm);
  }, [searchTerm]);

  const filtered_orders = (searchItem) => {
    if (searchItem)
    {
      let displayedOrders;

      displayedOrders = page_data?.filter((item) => {
        const combinedParams = [
          item.order_ref_number,
          item.order_name,
          item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
          item.status?.replace(/_/g, ' ').toUpperCase(),
        ]
          .join(" ")
          .toLowerCase();

        return combinedParams.includes(searchItem.toLowerCase());
      }).slice(startIndex, endIndex);

      setCurrentPageData(displayedOrders);
    } else
    {
      setCurrentPageData(page_data);
    }
  };


  const retrieve_orders = () => {
    setError("");
    // Retrieve Products
    dispatch(tenant_auth_actions_helper(loading_retrieve_sales_rep_tenant_order_list, success_retrieve_sales_rep_tenant_order_list, fail_retrieve_sales_rep_tenant_order_list, RETRIEVE_TENANT_ORDERS_LIST_ERROR_MSG, RETRIEVE_TENANT_ORDERS_LIST_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${SALES_REP_APPROVER_RETRIEVE_ORDER_LIST_API}`));
  };

  // Listen
  const retrieve_retrieve_sales_rep_tenant_order_list = useSelector((state) => state.retrieve_sales_rep_tenant_order_list.retrieve_sales_rep_tenant_order_list);

  useEffect(() => {
    if (retrieve_retrieve_sales_rep_tenant_order_list.status !== app_consts.IDLE)
    {
      if (retrieve_retrieve_sales_rep_tenant_order_list.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        setLoading(false);
        if (retrieve_retrieve_sales_rep_tenant_order_list.status === app_consts.FAIL)
        {
          setError(retrieve_retrieve_sales_rep_tenant_order_list.message);
          messageToast(retrieve_retrieve_sales_rep_tenant_order_list.message, app_consts.FAIL);
        } else if (retrieve_retrieve_sales_rep_tenant_order_list.status === app_consts.SUCCESS)
        {
          setCurrentPageData(retrieve_retrieve_sales_rep_tenant_order_list.data);
          setPageData(retrieve_retrieve_sales_rep_tenant_order_list.data);
        }
        dispatch(reset_retrieve_sales_rep_tenant_order_list());
      }
    }
  }, [retrieve_retrieve_sales_rep_tenant_order_list]);

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Order` : "Orders"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>All Orders</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && `Orders ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_orders();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand me-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    updateSm(!sm);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                {
                  !(loading || error) && (
                    <>
                      <div className="toggle-expand-content " style={{ display: sm ? "block" : "none" }}>
                        <ul className="py-4 w-100 g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Orders"
                              />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </>
                  )
                }
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Destination/Name</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">Behalf Of</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">Products</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">Date Created</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/all_orders/${item?.order_ref_number}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.order_name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                            <span>{item?.order_ref_number || "--"} </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span className="tb-lead">
                                            {item?.behalf_of === app_consts.SELF ? item?.sales_rep?.name : item?.agency?.name}
                                            <span className="dot dot-success d-md-none ms-1"></span>
                                          </span>
                                          <span>{formatToSentenceCase(item?.behalf_of || "--")} </span>
                                        </div>
                                      </div>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span className="tb-odr-date">{item?.no_of_products || 0}</span>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <span className="tb-odr-date">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.APPROVED_LOWER || item?.status === app_consts.DISPATCHED_LOWER
                                              ? "success"
                                              : "warning"
                                          }
                                          className="badge-dot"
                                        >
                                          {item ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link to={`/${tenant_info.url_prefix}/all_orders/${item?.order_ref_number}`}>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Link to={`/${tenant_info.url_prefix}/all_orders/${item?.order_ref_number}`}>
                                        <Button className="btn-pd-auto d-sm-none">
                                          <Icon name="chevron-right"></Icon>
                                        </Button>
                                      </Link>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : <div className="ms-2">No Orders found</div>}
                            </div>
                            {currentItems.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Orders Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>

    </>
  );
};

export default AllOrders;